var disponibilidade = [];
var message = false;
var company = false;
jQuery(function ($) {
  $(document).ready(function () {
    const locale = getLocale() === 'pt' ? 'pt-br' : getLocale();
    let translation = {
      select: 'Selecione',
      robot_confirmation: 'Confirme que você não é um robô'
    };
    if (getLocale() === 'en') {
      translation.select = 'Select';
      translation.robot_confirmation = 'Confirm that you are not a robot';
    }
    if (getLocale() === 'es') {
      translation.select = 'Seleccionar';
      translation.robot_confirmation = 'Confirma que no eres un robot'
    }

    $("body").append(`<script src="https://www.google.com/recaptcha/api.js?hl=${locale}" async defer></script>`);

    $("body").prepend(`<!-- Modal -->
      <div aria-hidden="true" aria-labelledby="scheduleModal" class="modal fade" id="scheduleModal" role="dialog" tabindex="-1">
          <div class="modal-dialog modal-lg" role="document" style="position:relative">
              <div class="modal-content">
                  <div class="row">

                      <div class="col-10 col-md-11 pt-4">
                          <h5 class="modal-title text-gradient mx-3">
                            <span class="language_pt-br d-none">COMO PODEMOS AJUDAR VOCÊ?</span>
                            <span class="language_en d-none">HOW CAN WE HELP YOU?</span>
                            <span class="language_es d-none">¿COMO PODEMOS AYUDARTE?</span>
                          </h5>
                      </div>

                      <div class="col-1 font-weight-bold">
                        <button aria-label="Close" id="scheduleModalButton" class="close mt-2 d-none d-sm-block" data-dismiss="modal" type="button">
                            <span aria-hidden="true">×</span>
                        </button>
                        <span class="d-sm-none d-block" style="font-size: 1.5em;"
                            onclick="document.getElementById('scheduleModalButton').click()">
                         x
                        </span>
                      </div>

                      <div class="col-12 my-4 d-lg-none">
                        <button class="btn-default bg-gradient text-white m-1 w-100" id="btn-schedule"
                          onclick="changeForm()" style="font-size:0.7em; color:#212529;" type="button">
                            <span class="language_pt-br d-none">ATENDIMENTO COM ESPECIALISTA</span>
                            <span class="language_en d-none">SERVICE WITH A SPECIALIST</span>
                            <span class="language_es d-none">SERVICIO CON UN PROFESIONAL</span>
                        </button>
                        <button class="btn-default m-1 w-100" id="btn-budget"
                          onclick="changeForm(1)" style="font-size:0.7em; color:#212529;" type="button">
                            <span class="language_pt-br d-none">SOLICITAR ORÇAMENTO</span>
                            <span class="language_en d-none">REQUEST A QUOTATION</span>
                            <span class="language_es d-none">SOLICITAR PRESUPUESTO</span>
                        </button>
                      </div>

                      <div class="col-12 my-4 d-none d-lg-block">
                        <button class="btn btn-default bg-gradient text-white m-1" id="btn-schedule"
                          onclick="changeForm()" style="width:260px;font-size:0.7em;" type="button">
                            <span class="language_pt-br d-none">ATENDIMENTO COM ESPECIALISTA</span>
                            <span class="language_en d-none">SERVICE WITH A SPECIALIST</span>
                            <span class="language_es d-none">SERVICIO CON UN PROFESIONAL</span>
                        </button>
                        <button class="btn btn-default m-1" id="btn-budget"
                          onclick="changeForm(1)" style="width:210px;font-size:0.7em;" type="button">
                            <span class="language_pt-br d-none">SOLICITAR ORÇAMENTO</span>
                            <span class="language_en d-none">REQUEST A QUOTATION</span>
                            <span class="language_es d-none">SOLICITAR PRESUPUESTO</span>
                        </button>
                      </div>

                      <div class="row mb-4">
                          <div class="col-12">
                              <form class="w-100" id="schedule-form">
                                  <h5 class="mx-3 mb-4">
                                  <span class="language_pt-br d-none">AGENDE UM ATENDIMENTO COM ESPECIALISTA</span>
                                  <span class="language_en d-none">SCHEDULE AN APPOINTMENT WITH A SPECIALIST</span>
                                  <span class="language_es d-none">PROGRAMAR UNA CITA CON UN ESPECIALISTA</span>
                                </h5>

                                  <div class="row">
                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                              <select name="idAtendente" required="required" placeholder="Assunto"
                                              style="border-bottom: 1px solid #1ab89c;color:black;">
                                                <option value="" class="language_es d-none">` + translation.select + `</option>
                                              </select>
                                              <label style="color: #1ab89c;font-size: 0.7em;">
                                                  <span class="language_pt-br d-none">Assunto</span>
                                                  <span class="language_en d-none">Subject</span>
                                                  <span class="language_es d-none">Sujeto</span>
                                              *</label>
                                          </div>
                                      </div>

                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                              <select name="areaAtuacao" required="required" placeholder="Área de atuação*"
                                              style="border-bottom: 1px solid #1ab89c;color:black;">
                                                <option value class="language_pt-br d-none">` + translation.select + `</option>
                                              </select>
                                              <label style="color: #1ab89c;font-size: 0.7em;">
                                                  <span class="language_pt-br d-none">Área de atuação</span>
                                                  <span class="language_en d-none">Occupation area</span>
                                                  <span class="language_es d-none">Área de actuación</span>
                                              *</label>
                                          </div>
                                      </div>
                                      <div class="col-12 col-lg-6" >
                                          <div class="label-float pl-0 date">
                                              <input autocomplete="off" name="data" disabled="disabled"
                                              required="required" type="text" style="border-bottom: 1px solid #1ab89c;color:black;"/>
                                              <label style="color: #1ab89c;font-size: 0.7em;">
                                                  <span class="language_pt-br d-none">Data</span>
                                                  <span class="language_en d-none">Date</span>
                                                  <span class="language_es d-none">Fecha</span>
                                              *</label>
                                          </div>
                                          <div id="ca" style="zoom: 75%; position: absolute;"></div>
                                      </div>
                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                            <input autocomplete="off" name="nomeCompleto"
                                              placeholder="Responsável" required="required"
                                              style="border-bottom: 1px solid #1ab89c;color:black;" type="text" />
                                              <label style="color: #1ab89c;font-size: 0.7em;">
                                                  <span class="language_pt-br d-none">Responsável</span>
                                                  <span class="language_en d-none">Responsible</span>
                                                  <span class="language_es d-none">Responsable</span>
                                              *</label>
                                          </div>
                                      </div>

                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                            <select name="hora" required="required" disabled="disabled"
                                                placeholder="horario" style="border-bottom: 1px solid #1ab89c;color:black;">
                                                <option value="" class="language_pt-br d-none">` + translation.select + `</option>
                                            </select>
                                            <label style="color: #1ab89c;font-size: 0.7em;">
                                                <span class="language_pt-br d-none">Horário</span>
                                                <span class="language_en d-none">Time</span>
                                                <span class="language_es d-none">Tiempo</span>
                                            *</label>
                                          </div>
                                      </div>

                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                            <input autocomplete="off" name="email"
                                              placeholder="E-mail" required="required" style="border-bottom: 1px solid #1ab89c;color:black;" type="email" />
                                            <label style="color: #1ab89c;font-size: 0.7em;">
                                                <span class="language_pt-br d-none">E-mail</span>
                                                <span class="language_en d-none">Email</span>
                                                <span class="language_es d-none">Correo Electrónico</span>
                                            *</label>
                                          </div>
                                      </div>

                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                            <input autocomplete="off" name="cnpj"
                                              placeholder="CNPJ" required="required" style="border-bottom: 1px solid #1ab89c;color:black;" type="text"
                                              onkeydown="Util.mascara('##.###.###/####-##',this,event,true)"/>
                                            <label style="color: #1ab89c;font-size: 0.7em;">
                                                <span class="language_pt-br d-none">CNPJ</span>
                                                <span class="language_en d-none">LEI</span>
                                                <span class="language_es d-none">NIF</span>
                                            *</label>
                                          </div>
                                      </div>

                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                            <input autocomplete="off" name="telefoneComercial"
                                              placeholder="Telefone" required="required" style="border-bottom: 1px solid #1ab89c;color:black;" type="text"
                                              onkeydown="Util.mascara('(##) #####-####',this,event,true)"/>
                                            <label style="color: #1ab89c;font-size: 0.7em;">
                                                <span class="language_pt-br d-none">Telefone</span>
                                                <span class="language_en d-none">Phone</span>
                                                <span class="language_es d-none">Teléfono</span>
                                            *</label>
                                          </div>
                                      </div>

                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                            <input autocomplete="off" name="razaoSocial"
                                              placeholder="Razão Social*" required="required"
                                              style="border-bottom: 1px solid #1ab89c;color:black;" type="text"/>
                                            <label style="color: #1ab89c;font-size: 0.7em;">
                                                <span class="language_pt-br d-none">Razão Social</span>
                                                <span class="language_en d-none">Company Name</span>
                                                <span class="language_es d-none">Razón Social</span>
                                            *</label>
                                          </div>
                                      </div>

                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                            <input autocomplete="off" name="nomeFantasia"
                                              placeholder="Nome Fantasia*" required="required"
                                              style="border-bottom: 1px solid #1ab89c;color:black;" type="text"/>
                                            <label style="color: #1ab89c;font-size: 0.7em;">
                                                <span class="language_pt-br d-none">Nome Fantasia</span>
                                                <span class="language_en d-none">Fantasy Name</span>
                                                <span class="language_es d-none">Nombre de Fantasía</span>
                                            *</label>
                                          </div>
                                      </div>

                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                            <input autocomplete="off" name="cep"
                                              placeholder="CEP*" required="required"
                                              style="border-bottom: 1px solid #1ab89c;color:black;" type="text"
                                              onkeydown="Util.mascara('##.###-###',this,event,true)"/>
                                            <label style="color: #1ab89c">
                                                <span class="language_pt-br d-none">CEP</span>
                                                <span class="language_en d-none">Postal Code</span>
                                                <span class="language_es d-none">Código Postal</span>
                                            *</label>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="w-100 py-4">
                                      <div class="row">
                                          <div class="col-12">
                                              <input required="required" type="checkbox"
                                                style="border-bottom: 1px solid #1ab89c;color:black;"/>
                                                <span class="language_pt-br d-none">
                                                  Eu li e aceito os termos de uso estabelecidos na
                                                  <a href="${SITEURL}/politica-de-privacidade" target="_blank">política de privacidade</a>
                                                </span>
                                                <span class="language_en d-none">
                                                  I have read and accept the terms of use set out in the
                                                  <a href="${SITEURL}/en/privacy-policy" target="_blank">privacy policy</a>
                                                </span>
                                                <span class="language_es d-none">
                                                  He leído y acepto las condiciones de uso establecidas en la
                                                  <a href="${SITEURL}/es/política-de-privacidad" target="_blank">política de privacidad</a>
                                                </span>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="w-100 py-4">
                                      <div class="g-recaptcha" data-sitekey="6LdX4P4oAAAAAKST0Bqt_heusb115y6jrY2ADQEQ"></div>
                                      <span class="text-danger"></span>
                                      <br/>
                                      <button class="btn btn-default bg-gradient text-white float-right"
                                        style="width:205px;font-size:0.7em">
                                        <span class="language_pt-br d-none">AGENDAR ATENDIMENTO</span>
                                        <span class="language_en d-none">SCHEDULE SERVICE</span>
                                        <span class="language_es d-none">HORARIOS DE SERVICIO</span>
                                      </button>
                                  </div>
                              </form>

                              <form class="w-100 d-none" id="budget-form">
                                  <h5 class="mx-3 mb-4">
                                    <span class="language_pt-br d-none">SOLICITE UM ORÇAMENTO</span>
                                    <span class="language_en d-none">REQUEST A QUOTATION</span>
                                    <span class="language_es d-none">SOLICITAR PRESUPUESTO</span>
                                  </h5>

                                  <div class="row">

                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                            <input autocomplete="off" name="nome"
                                              placeholder="Nome Completo*" required="required" style="border-bottom: 1px solid #1ab89c;color:black;" type="text" />
                                            <label style="color: #1ab89c">
                                              <span class="language_pt-br d-none">Nome Completo</span>
                                              <span class="language_en d-none">Full Name</span>
                                              <span class="language_es d-none">Nombre completo</span>
                                            *</label>
                                          </div>
                                      </div>

                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                            <input autocomplete="off" name="razao"
                                              placeholder="Razão Social*" required="required" style="border-bottom: 1px solid #1ab89c;color:black;" type="text" />
                                            <label style="color: #1ab89c">
                                              <span class="language_pt-br d-none">Razão Social</span>
                                              <span class="language_en d-none">Company Name</span>
                                              <span class="language_es d-none">Razón Social</span>
                                            *</label>
                                          </div>
                                      </div>

                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                            <input autocomplete="off" name="cnpj"
                                              placeholder="CNPJ*" required="required" style="border-bottom: 1px solid #1ab89c;color:black;" type="text"
                                              onkeydown="Util.mascara('##.###.###/####-##',this,event,true)"/>
                                            <label style="color: #1ab89c;font-size: 0.7em;">
                                              <span class="language_pt-br d-none">CNPJ</span>
                                              <span class="language_en d-none">LEI</span>
                                              <span class="language_es d-none">NIF</span>
                                            *</label>
                                          </div>
                                      </div>

                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                            <input autocomplete="off" name="email"
                                              placeholder="E-mail*" required="required" style="border-bottom: 1px solid #1ab89c;color:black;" type="email" />
                                            <label style="color: #1ab89c;font-size: 0.7em;">
                                              <span class="language_pt-br d-none">E-mail</span>
                                              <span class="language_en d-none">Email</span>
                                              <span class="language_es d-none">Correo Electrónico</span>
                                            *</label>
                                          </div>
                                      </div>

                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                            <input autocomplete="off" name="telefone"
                                              placeholder="Telefone*" required="required" style="border-bottom: 1px solid #1ab89c;color:black;" type="text"
                                              onkeydown="Util.mascara('(##) #####-####',this,event,true)"/>
                                            <label style="color: #1ab89c;font-size: 0.7em;">
                                              <span class="language_pt-br d-none">Telefone</span>
                                              <span class="language_en d-none">Phone</span>
                                              <span class="language_es d-none">Teléfono</span>
                                            *</label>
                                          </div>
                                      </div>

                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                              <select name="field_selecione_o_assunto[]" required="required" placeholder="Selecione uma opção*"
                                              style="border-bottom: 1px solid #1ab89c;color:black;">
                                                <option value>` + translation.select + `</option>
                                                <option value="7279">Avaliação de maturidade</option>
                                                <option value="01584">Plano de Ação</option>
                                                <option value="56846">Conheça o Intercâmbio Comercial de Seu Produto</option>
                                                <option value="56844">Analise o Mercado Alvo</option>
                                                <option value="56847">Encontre Potenciais Mercados</option>
                                                <option value="56845">Encontre Potenciais Clientes no Exterior</option>
                                                <option value="58490">Avalie a Competitividade Brasileira e a Concorrência no Mercado-Alvo</option>
                                                <option value="7276">Formule Seus Preços</option>
                                                <option value="1492">Diretório de empresas exportadoras de SC</option>
                                                <option value="1491">Diretório de empresas importadoras de SC</option>
                                                <option value="7275">Estatísticas de exportação/importação</option>
                                                <option value="1005195">Certificados de Exportação</option>
                                                <option value="7277">Estudos customizados</option>
                                                <option value="60474">Desenvolvimento de fornecedores no exterior</option>
                                                <option value="60473">Desenvolvimento de fornecedores no Brasil</option>
                                                <option value="7374">Plataforma de Internacionalização</option>
                                              </select>
                                              <label style="color: #1ab89c;font-size: 0.7em;">Selecione uma opção*</label>
                                          </div>
                                      </div>

                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                            <input autocomplete="off" id="produto" name="field_produto_a_ser_analizado_co[0][value]" placeholder="Produto a ser analisado (NCM/SH e descrição)*"
                                                required="required" style="border-bottom: 1px solid #1ab89c;color:black;" type="text" />
                                            <label style="color: #1ab89c;font-size: 0.7em;">
                                              <span class="language_pt-br d-none">Produto a ser analisado (NCM/SH e descrição)</span>
                                              <span class="language_en d-none">Product to be analyzed</span>
                                              <span class="language_es d-none">Producto a analizar</span>
                                            *</label>
                                          </div>
                                      </div>

                                      <div class="col-12 col-lg-6">
                                          <div class="label-float pl-0">
                                            <input autocomplete="off" name="field_mercado[0][value]"
                                              placeholder="Mercado*" required="required" style="border-bottom: 1px solid #1ab89c;color:black;" type="text" />
                                            <label style="color: #1ab89c;font-size: 0.7em;">
                                              <span class="language_pt-br d-none">Mercado</span>
                                              <span class="language_en d-none">Market</span>
                                              <span class="language_es d-none">Mercado</span>
                                            *</label>
                                          </div>
                                      </div>

                                      <div class="col-12">
                                          <div class="label-float pl-0">
                                            <input autocomplete="off" name="mensagem"
                                              placeholder="Mensagem*" required="required" style="border-bottom: 1px solid #1ab89c;color:black;" type="text" />
                                            <label style="color: #1ab89c;font-size: 0.7em;">
                                              <span class="language_pt-br d-none">Mensagem</span>
                                              <span class="language_en d-none">Message</span>
                                              <span class="language_es d-none">Mensaje</span>
                                            *</label>
                                          </div>
                                      </div>

                                  </div>

                                  <div class="w-100 py-4">
                                      <div class="g-recaptcha" data-sitekey="6LdX4P4oAAAAAKST0Bqt_heusb115y6jrY2ADQEQ"></div>
                                      <span class="text-danger"></span>
                                      <br/>
                                      <button class="btn btn-default bg-gradient text-white float-right"  style="width:200px;font-size:0.7em">
                                        <span class="language_pt-br d-none">SOLICITAR ORÇAMENTO</span>
                                        <span class="language_en d-none">REQUEST A QUOTATION</span>
                                        <span class="language_es d-none">SOLICITAR PRESUPUESTO</span>
                                      </button>
                                  </div>
                              </form>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>`);

    getAtendentes();
    getAreasAtuacao();

    var urlSearch = new URLSearchParams(window.location.search);
    if(urlSearch.get('') == 'agendamento' || urlSearch.get('agendamento') != null){
      $(".modal#scheduleModal").modal('show');
      changeForm();
    }

    if(urlSearch.get('') == 'orcamento' || urlSearch.get('orcamento') != null){
      $(".modal#scheduleModal").modal('show');
      changeForm(1);
    }

    $( ".modal#scheduleModal" ).on('shown.bs.modal', function(){
      if(message && document.location.search !== '?agendamento'){
        alert("No momento não há horários disponíveis para agendamento." +
          " Favor entrar em contato através da ferramenta de chat disponível na plataforma.");
        message = false;
      }

      if(company == false && localStorage.company_id && localStorage.company_id != 'null'){
        $.ajax({
          url: APIURL + `/company/${localStorage.company_id}`,
          headers: {
            "identifier": Util.getIdentifier()
          },
          type: 'get',
          success: function (r) {
            setDataFromCompany(r, true);
          }
        });
      }
    });

    $(".modal#scheduleModal input[name=cnpj]").on("change", function () {
      $.ajax({
        url: APIURL + `/company?cnpj=${$(".modal#scheduleModal input[name=cnpj]").val()}`,
        headers: {
          "identifier": Util.getIdentifier()
        },
        type: 'get',
        success: function (r) {
          if(r.length){
            setDataFromCompany(r[0]);
          }
        }
      });
    });

    $("select[name=idAtendente]").on('change', function (){
      disponibilidade = [];
      $("input[name=data], select[name=hora]").attr('disabled', 'disabled');
      var id = $("select[name=idAtendente]").val();
      if(id){
        $.ajax({
          url: APIURL + `/atendente/${id}`,
          headers: {
            "identifier": Util.getIdentifier()
          },
          type: 'get',
          success: function (r) {
            disponibilidade = r.disponibilidade;

            if(r.disponibilidade){
              $("input[name=data], select[name=hora]").removeAttr('disabled');
            }
           $("#ca").calendar({
              width: 300,
              trigger: '.modal#scheduleModal input[name=data]',
              height: 300,
              startWeek: 0,
              format: 'dd/mm/yyyy',
              weekArray: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
              monthArray: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
              date: new Date(),
              onSelected: function (view, date, data) {
                getHoras(date);
              },
              viewChange: function (view, y, m) {
              }
            });
            $("#ca").calendar('setRange',getDiasComHorarios());
            $("input[name=data], select[name=hora]").val('');
          }
        });
      }
    });

    function getAreasAtuacao() {
      var html = "<option value='0'>" + translation.select + "</option>";

      var modal = $(".modal#scheduleModal #schedule-form");
      modal.find('select[name=areaAtuacao]').html(html);
      $('#areaAtuacao').html(html);

      $.ajax({
        url: APIURL + '/areas_de_atuacaos',
        headers: {
          "Accept": "Application/json",
          "identifier": Util.getIdentifier()
        },
        type: 'get',
        success: function (r) {
          r.forEach(element => {
            html += `<option value="${element.id}">${element.nome}</option>`;
          });
          modal.find('select[name=areaAtuacao]').html(html);
          $('#areaAtuacao').html(html);
        }
      });
    }

    function getAtendentes(){
      $.ajax({
        url: APIURL + '/atendente?suspenso=false&ativo=true',
        headers: {
          "identifier": Util.getIdentifier()
        },
        type: 'get',
        success: function (r) {
          message = !r.length;
          var html = "<option value=''>" + translation.select + "</option>";
          for (var i in r) {
            html += `<option value='${r[i].id}'>${r[i].assunto}</option>`;
          }
          $("select[name=idAtendente]").html(html);
        }
      });
    }

    function setDataFromCompany(r, check = null) {
      company = true;
      var modal = $(".modal#scheduleModal #schedule-form");
      modal.find('input[name=razaoSocial]').val(r.razaoSocial);
      modal.find('input[name=nomeFantasia]').val(r.nomeFantasia);
      if (check) {
        modal.find('select[name=areaAtuacao]').val(r.areaAtuacao);
        modal.find('input[name=cnpj]').val(r.cnpj);
        modal.find('input[name=telefoneComercial], input[name=telefone]').val(r.telefoneComercial);
        modal.find('input[name=cep]').val(r.cep);
        modal.find('#produto').val(r.produto);
        modal.find('input[name=nomeCompleto]').val(localStorage.nomeCompleto);
        modal.find('input[name=email]').val(localStorage.email);
        modal.find('input[name=cnpj]').keydown();
        modal.find('input[name=cep]').keydown();
      }
    }

    function getDiasComHorarios(){
      var diasComHorarios = [];
      Object.keys(disponibilidade).forEach((element)=>{
        if(disponibilidade[element].length > 0 ){
          diasComHorarios.push(element);
        }
      });
      return diasComHorarios;
    }

    function getHoras(date){
      var html = "<option value=''>" + translation.select + "</option>";
      var data = date.toLocaleDateString().split(' ');
      var data = data[0].split('/');
      if(disponibilidade[data[2]+'-'+data[1]+'-'+data[0]] != undefined){
        var value;
        for(var i in disponibilidade[data[2]+'-'+data[1]+'-'+data[0]]){
          value = disponibilidade[data[2]+'-'+data[1]+'-'+data[0]][i];
          html += `<option value="${value[0]}">${value[0]} às ${value[1]}</option>`;
        }
      }
      $('.modal#scheduleModal select[name=hora]').html(html);
    }

    $('.modal#scheduleModal input[name=data]').on("change", function (){
      var html = "<option value=''>" + translation.select + "</option>";
      var data = $('.modal#scheduleModal input[name=data]').val();
      if(disponibilidade[data] != undefined){
        var value;
        for(var i in disponibilidade[data]){
          value = disponibilidade[data][i];
          html += `<option value="${value[0]}">${value[0]} às ${value[1]}</option>`;
        }
      }
      $('.modal#scheduleModal select[name=hora]').html(html);
    });

    $("form#schedule-form, form#budget-form").on("submit", function (e){
      e.preventDefault();
    });

    $("form#schedule-form").on("submit", function (){
      blockScreen();
      var data = {};
      var dataArray = $("form#schedule-form").serializeArray();
      for (var i in dataArray) {
        data[dataArray[i].name] = dataArray[i].value;
        if(dataArray[i].name === 'data'){
          var novadata =  dataArray[i].value.split('/')
          data[dataArray[i].name] = novadata[2]+'-'+novadata[1]+'-'+novadata[0];
        }
      }
      if(!data['g-recaptcha-response']){
        unBlockScreen();
        document.querySelector('form#schedule-form .text-danger').innerHTML = translation.robot_confirmation;
        return;
      }
      document.querySelector('form#schedule-form .text-danger').innerHTML = '';
      $.ajax({
        url: APIURL + '/agendamento',
        headers: {
          "identifier": Util.getIdentifier()
        },
        type: 'post',
        data: data,
        success: function (rs) {
          unBlockScreen();
          alert(rs.message);
          $("select[name=idAtendente]").trigger("change");
          $("select, input").val('');
          $(".modal#scheduleModal").modal("hide");
        },
        error: function (rs) {
          unBlockScreen();
          alert(JSON.parse(rs.responseJSON.message));
        }
      });
    });

    $("form#budget-form").on("submit", function (){
      blockScreen();
      var data = {};
      var dataArray = $("form#budget-form").serializeArray();
      for (var i in dataArray) {
        data[dataArray[i].name] = dataArray[i].value;
      }
      if(!data['g-recaptcha-response']){
        unBlockScreen();
        document.querySelector('form#budget-form .text-danger').innerHTML = 'Confirme que você não é um robô';
        return;
      }
      document.querySelector('form#budget-form .text-danger').innerHTML = '';
      $.ajax({
        url: APIURL + '/email/orcamento',
        headers: {
          "identifier": Util.getIdentifier()
        },
        type: 'post',
        data: JSON.stringify(data),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: function (rs) {
          unBlockScreen();
          alert("Orçamento enviado com Sucesso");
          $("select, input").val('');
          $(".modal#scheduleModal").modal("hide");
        },
        error: function (r) {
          unBlockScreen();
        }
      });
      $.ajax({
        url: APIURL + '/atividade',
        headers: {
          "identifier": Util.getIdentifier()
        },
        type: 'post',
        data: JSON.stringify(data),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: function (data) {
        },
        error: function (r, s, e) {
          console.log(r.responseText);
        }
      });
    });
  });
});

function changeForm(info = null) {
  window.history.replaceState(null, null, info == null ? '?=agendamento' : '?=orcamento');
  var btnToAdd = document.querySelectorAll(!info ? '#btn-schedule' : '#btn-budget');
  var btnToRemove = document.querySelectorAll(info ? '#btn-schedule' : '#btn-budget');
  var formToShow = document.querySelector(!info ? '#schedule-form' : '#budget-form');
  var formToHide = document.querySelector(info ? '#schedule-form' : '#budget-form');
  for(var i=0;i<2;i++){
    btnToAdd[i].classList.add('bg-gradient');
    btnToAdd[i].classList.add('text-white');
    btnToRemove[i].classList.remove('bg-gradient');
    btnToRemove[i].classList.remove('text-white');
  }
  formToShow.classList.remove('d-none');
  formToHide.classList.add('d-none');
}
